import React from 'react';

export default () => (
  <footer className="footer-area">
    <div className="container">
      <div className="row">
        <ul className="list-inline text-center">
          <li>Code Corn</li>
          <li>NASA Space Apps Challenge 2018</li>
          <li><a href="https://github.com/zonayedpca/nasa-rocket-launch">Source Code</a></li>
        </ul>
      </div>
    </div>
  </footer>
)
